import { render, staticRenderFns } from "./PropertyOwnersList.vue?vue&type=template&id=2f953383&"
import script from "./PropertyOwnersList.vue?vue&type=script&lang=js&"
export * from "./PropertyOwnersList.vue?vue&type=script&lang=js&"
import style0 from "./PropertyOwnersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports